// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__xIHPE","truncatedText":"styles_truncatedText__Als91","fullText":"styles_fullText__L7gw5","textContainer":"styles_textContainer__4uGlr"};